import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import { getUserXPData } from '../services/xpService';
import './XPDisplay.css';

const XPDisplay = ({ user }) => {
    const [xpData, setXPData] = useState({ totalXP: 0, streak: 0 });
    const [showPopup, setShowPopup] = useState(false);
    const [popupXP, setPopupXP] = useState(0);
    const [refreshKey, setRefreshKey] = useState(0);

    const fetchXPData = async () => {
        try {
            if (user?.uid) {
                console.log('Fetching XP data for user:', user.uid);
                const data = await getUserXPData(user.uid);
                console.log('Received XP data:', data);
                setXPData(data);
            }
        } catch (error) {
            console.error('Error fetching XP data:', error);
        }
    };

    // Fetch XP data when component mounts, when user changes, or when refreshKey changes
    useEffect(() => {
        fetchXPData();
    }, [user?.uid, refreshKey]);

    // Handle XP updates
    useEffect(() => {
        const handleXPUpdate = (newXP) => {
            setPopupXP(newXP);
            setShowPopup(true);
            // Force a refresh of XP data
            setRefreshKey(prev => prev + 1);
            setTimeout(() => setShowPopup(false), 2000);
        };

        // Set up global handler for XP updates
        window.xpUpdateHandler = handleXPUpdate;

        return () => {
            window.xpUpdateHandler = null;
        };
    }, []);

    // Refresh XP data periodically (every 30 seconds)
    useEffect(() => {
        const interval = setInterval(() => {
            setRefreshKey(prev => prev + 1);
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    if (!user) return null;

    return (
        <div className="xp-display">
            <div className="xp-container">
                <FaStar className="xp-icon" />
                <span className="xp-value">{xpData.totalXP} XP</span>
            </div>
            {xpData.streak > 0 && (
                <div className="streak-badge">
                    🔥 {xpData.streak} day streak
                </div>
            )}
            {showPopup && (
                <div className="xp-popup">
                    +{popupXP} XP
                </div>
            )}
        </div>
    );
};

export default XPDisplay; 